/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Direct_Feature_CabinetInputs */

const en_home_direct_feature_cabinet = /** @type {(inputs: Home_Direct_Feature_CabinetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your booking in one place`)
};

/**
* | output |
* | --- |
* | "Your booking in one place" |
*
* @param {Home_Direct_Feature_CabinetInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_direct_feature_cabinet = /** @type {((inputs?: Home_Direct_Feature_CabinetInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Direct_Feature_CabinetInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_direct_feature_cabinet(inputs)
});